module.exports = __webpack_public_path__ + "static/media/acto_de_grado_0.df213957.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/acto_de_grado_0.jpg
// module id = 907
// module chunks = 0